<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp dp-none">
          <sidebar :cargo="cargo"/>
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp tile-r">
          <div class="tile is-parent is-12 zeromp dp-none">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>

          <internnavbarmobile class="internNavM" />

          <div class="tile is-vertical is-12 internbackground tile-r">
            <div class="tile is-parent is-vertical">
              <div class="tile is-child">
                <p class="indextitle">{{TitleIndex}}</p>

                <section id="redacao-tile" class>
                  <section id="entity-content">
                    <redacao-form
                        :formtitle="TitleForm"
                        :redacao="redacao"
                        @formSubmit="FormSubmit"
                        buttom="Enviar Redação"
                    />
                  </section>
                </section>
              </div>
              <internfooter class="dp-none" />
              <bottomtabsmobile />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import RedacaoService from "@/services/RedacaoService";
//import RedacaoForm from "@/components/AlunoView/Redacao/Form";
import RedacaoForm from "@/components/Forms/RedacaoSave";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";
import internnavbarmobile from "@/components/Navbars/InternNavMobile";
import bottomtabsmobile from "@/components/Tabs/BottomNavigationMobile";

export default {
  name: "redacaoNew",
  props: [],
  created() {
    var RedacaoId = this.$router.history.current.params.uuid;

    if(RedacaoId != null){
        RedacaoService.Info(RedacaoId).then(result => {
            this.redacao = result.data;
        });
    }
  },
  methods: {
    CreateRedacao(redacao) {
      RedacaoService.Create(redacao).then(() => {
        this.$buefy.toast.open({
          duration: 5000,
          message: "redacao criado com sucesso!",
          position: "is-top-right",
          type: "is-success"
        });
        this.$router.push({ name: "redacao" });
      });
    },
    UpdateRedacao(redacao) {
      RedacaoService.Update(this.$route.params.uuid, redacao).then(() => {
        this.$buefy.toast.open({
          duration: 5000,
          message: "redacao alterada com sucesso!",
          position: "is-top-right",
          type: "is-success"
        });
        this.$router.push({ name: "redacao" });
      });
    },
    FormSubmit(redacao){
      if(this.redacao.id == ""){
        this.CreateRedacao(redacao);
      }else{
        this.UpdateRedacao(redacao);
      }
    }
  },
  components: {
    RedacaoForm: RedacaoForm,
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    internnavbarmobile: internnavbarmobile,
    bottomtabsmobile: bottomtabsmobile
  },
  data() {
    return {
      redacao: {
        id: "",
        proposta_id: "",
        aluno_id: store.getters.cargo_id,
        file: ""
      },
      cargo: store.getters.cargo,
      cargoId: store.getters.cargo_id
    };
  },
  computed: {
    TitleForm: function(){
        return this.redacao.id == "" ? "Adicionar Nova Redação" : "Editar Redação";
    },
    TitleIndex: function(){
        return this.redacao.id == "" ? "Subir Nova Redação" : "Alterar Redação";
    }
  }
};
</script>
<style scoped>
.internNavM,
.tabs-mobile {
  display: none;
}
@media only screen and (max-width: 720px) {
  .internNavM,
  .tabs-mobile {
    display: block;
  }
  .tile-r {
    margin-top: 45px !important;
  }
}
</style>